import { z } from 'zod';

/**
 * Body de `POST /api/v1/proyectos/:id/solicitantes`.
 * Espeja `AssignSolicitanteDto` del backend (`usuarioId: number`).
 */
export const asignarSolicitanteSchema = z.object({
  usuarioId: z.coerce.number().int().positive('Seleccione un solicitante de la lista.'),
});

/**
 * Query de `GET /api/v1/proyectos/usuarios-disponibles?rol=Solicitante`.
 * El endpoint unificado decide por `rol` qué pool de candidatos lista —
 * este schema fija `rol = 'Solicitante'` y solo expone los filtros
 * aplicables. Cuando `proyectoId` viene definido, el backend excluye
 * solicitantes ya asignados a ese proyecto.
 */
export const filtrosSolicitantesDisponiblesSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().optional(),
  proyectoId: z.coerce.number().int().positive().optional(),
});

export type AsignarSolicitanteInput = z.infer<typeof asignarSolicitanteSchema>;
export type FiltrosSolicitantesDisponiblesInput = z.infer<
  typeof filtrosSolicitantesDisponiblesSchema
>;
